import { useStoryblok, storyblokClient } from "../storyblok"
import { Page, Section } from "components"
import Head from "next/head"
import type { NextPage } from "next"
import type { NavigationItem } from "components/Page/Navigation"


const NAVIGATION_MAP: NavigationItem[] = [{
  path: '#home',
  text: 'Home',
  description: 'Learn more about'
}, {
  path: '#about-me',
  text: 'About me',
  description: 'Read about my summary and techstack'
}, {
  path: '#experience',
  text: 'Experience',
  description: 'Explore my career timeline',
}, {
  path: '#contact',
  text: 'Contact',
  description: 'Let\'s cooperate!'
}]

const TITLE = 'Pavló Valor - Software Engineer'

const HomePage: NextPage = story => {
  const data = useStoryblok(story as any)

  return (
    <Page.Context.Provider value={data}>
      <Head>
        <title>{TITLE}</title>
        <meta name="description" content="My personal page which describes my values, experience, and knowledge."/>
        <meta name="keywords" content="software, engineer, portfolio, resume, cv, curriculum, vitae" />
        <meta property="og:title" content={TITLE} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/preview.webp" />
      </Head>
      <Page.Container itemScope itemType="http://schema.org/Person">
        <Page.Navigation map={NAVIGATION_MAP} />
        <Page.Header />
        <Section.Services />
        <Section.AboutMe />
        <Section.CareerTimeline />
        <Section.Projects />
        <Section.Feedback />
        <Section.Activities />
        <Page.Footer />
      </Page.Container>
    </Page.Context.Provider>
  )
}

export default HomePage
export async function getStaticProps(/*{ locale, preview }*/) {
  const { data: { story }} = await storyblokClient.get(`cdn/stories/home`, {
    version: 'published',
    cv: Date.now(),
  })

  return {
    props: story,
    revalidate: 10, 
  }
}
